import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import isEmpty from 'lodash/isEmpty';
import classNames from 'classnames/bind';
import { detectisIE } from 'yoda-core-components/lib/helpers/Utils/Utils';
import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';
import ContactInformation from '../../../../../components/ContactInformation/ContactInformation';
import ShippingGroupList from '../../../../../components/ShippingGroupList/ShippingGroupList';
import SpecialFinancingOfferInformation from '../../../../../components/SpecialFinancingOfferInformation/SpecialFinancingOfferInformation';
import OrderNumber from '../OrderNumber/OrderNumber';
import BillingAddressDetails from '../../../../../components/BillingAddressDetails/BillingAddressDetails';
// eslint-disable-next-line import/no-named-as-default
import OrderSummary from '../../../../../components/OrderSummary/OrderSummary';
import ConfirmationGiftWrapper from '../ConfirmationGiftWrapper/ConfirmationGiftWrapper';
import * as styles from './ConfirmationDetails.css';

const cx = classNames.bind(styles);

function ConfirmationDetails({ orderInfo, orderBillingInfo, orderContactInfo, orderGiftWrapInfo }) {
    if (isEmpty(orderInfo) || isEmpty(orderBillingInfo) || isEmpty(orderContactInfo)) {
        return null;
    }
    const orderSummary = detectisIE()
        ? `${styles.orderSummaryIE} ${dt([
              'smOnly:py-0',
              'smOnly:px-2',
              'md:pt-1.5',
              'md:px-4',
              'md:pb-6',
          ])}`
        : `${styles.orderSummary} ${dt(['p-6'])}`;
    return (
        <div>
            <div
                data-automation-id="at-confirmation-details"
                className={`${styles.confirmationDetails} ${dt(['bg-light-white', 'p-6'])}`}
            >
                <div className={`${cx('col12', 'orderNumber')} ${dt(['text-large', '!p-0'])}`}>
                    <OrderNumber orderId={orderInfo.number} />
                </div>
                <div
                    className={`${cx('sm12', 'md12', 'lg12', 'xl12', 'contactInfo')} ${dt([
                        'text-medium',
                        'mt-4',
                        '!p-0',
                    ])}`}
                    data-automation-id="at-ocp-contactinfo-block"
                >
                    <ContactInformation
                        userFirstName={orderBillingInfo.firstName}
                        userLastName={orderBillingInfo.lastName}
                        userEmailId={orderContactInfo.emailId}
                        userPhoneNumber={orderBillingInfo.phone}
                        transactionalSMSNumber={orderContactInfo.phoneNumber}
                    />
                </div>
                <div
                    className={`${cx('sm12', 'md12', 'lg12', 'xl12', 'billingInfo')} ${dt([
                        'text-medium',
                        'mt-4',
                        '!p-0',
                    ])}`}
                    data-automation-id="at-ocp-billinginfo-block"
                >
                    <BillingAddressDetails billingInfo={orderBillingInfo} />
                </div>
                {!isEmpty(orderInfo.financing) && (
                    <SpecialFinancingOfferInformation financing={orderInfo.financing} ocp />
                )}
            </div>
            <div data-automation-id="at-shipping-group">
                <ShippingGroupList />
            </div>
            <div>{!isEmpty(orderGiftWrapInfo) ? <ConfirmationGiftWrapper /> : ''}</div>
            <div className={orderSummary}>
                <OrderSummary showOrderSummaryTitle />
            </div>
        </div>
    );
}

ConfirmationDetails.propTypes = {
    orderInfo: PropTypes.objectOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number]))
        .isRequired,
    orderBillingInfo: PropTypes.objectOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number]))
        .isRequired,
    orderContactInfo: PropTypes.objectOf(PropTypes.string).isRequired,
    orderGiftWrapInfo: PropTypes.arrayOf(PropTypes.object).isRequired,
};

const mapStateToProps = ({ orderInfo, orderBillingInfo, orderContactInfo, orderGiftWrapInfo }) => ({
    orderInfo,
    orderBillingInfo,
    orderContactInfo,
    orderGiftWrapInfo,
});

export default connect(mapStateToProps)(ConfirmationDetails);
